interface ButtonProps {
    children: React.ReactNode;
    onClick?: () => void;
    className?: string;
    disabled?: boolean;
}

export const OutlineButton = ({ children, onClick, className = 'px-2.5 py-4 flex-1', disabled = false }: ButtonProps) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`rounded-2xl outline outline-1 outline-offset-[-1px] outline-white 
                text-white text-base font-medium font-outfit leading-6 
                hover:bg-primary hover:outline-primary hover:text-primary-content 
                transition-all duration-200 
                disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
        >
            {children}
        </button>
    );
};